import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import {
  AbstractSearchCore,
  AbstractSubscriber,
  IFacet,
  ISearchConfig,
  MultipleResults,
} from '../../modules/search'

Locale.getInstance().registerKeySet('fr', 'lvc-activity-pack', {
  viewMore: 'voir tous les événements {{title}}',
})
Locale.getInstance().registerKeySet('en', 'lvc-activity-pack', {
  viewMore: 'see all {{title}} events',
})

export enum PrebuiltPacks {
  recommended = 'recommended',
  nearMe = 'nearMe',
  thisWeek = 'thisWeek',
  free = 'free',
  everyone = 'everyone',
  familyFriendly = 'familyFriendly',
  expositions = 'expositions',
  series = 'series',
}
export enum FlexDate {
  thisWeek = 'this week',
  thisWeekend = 'this weekend',
  nextWeek = 'next week',
  nextWeekend = 'next weekend',
  thisMonth = 'this month',
}
export interface DataPackConfig {
  title: {
    fr: string
    en: string
  }
  type: string
  startDate: string
  endDate: string
  flexDate: FlexDate
  limit: number
  sortBy?: string
  audience: string[]
  discipline: string[]
  city: string[]
  radius: number
  isAccessibleForFree: boolean
  clientId: number
  eventList?: { url: string }[]
}

export interface LvcActivityPack {
  items: any[]
  total: number | ''
}

export class LvcActivityPackSubscriber extends AbstractSubscriber {
  _core: AbstractSearchCore | null = null
  _initialized = false
  searchConfig: ISearchConfig = {}

  constructor(groupId?: string) {
    super(groupId || 'activity-pack')
    // Note: We don't auto-subscribe here anymore since the component will handle subscription
  }

  async attached(searchCore: AbstractSearchCore) {
    this._core = searchCore
    this._initialized = true
  }

  detaching(): void {}

  async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {}

  async onSearchTextUpdate(text: string): Promise<void> {}

  async onFacetUpdate(facet: IFacet[]): Promise<void> {}

  async onResultUpdate(results: MultipleResults): Promise<void> {}

  async goToSearch(goToSearch = true): Promise<void> {}
}

export interface LvcActivityPack {
  dataPackConfig: string
  layout: 'grid' | 'slider'
  prebuiltTag?: PrebuiltPacks
  items: any[]
  total: number | ''
  title: string
}
export class LvcActivityPack extends MinzeElement {
  attrs: Attrs = ['title', 'data-pack-config', 'layout']
  items = [] as any[]
  total = 0 as number | ''

  parsedData = {} as DataPackConfig

  isMobile = window.matchMedia('(max-width: 730px)').matches

  private subscriber: LvcActivityPackSubscriber = new LvcActivityPackSubscriber()

  viewMore = async () => {
    await this.subscriber.goToSearch(true)
  }
  isDisableSeeMore = () => {
    return this.parsedData.eventList && this.parsedData.eventList.length > 1
  }
  html = () => `
    <lvc-activity-pack-layout items="${JSON.stringify(this.items)}" title=${this.title} layout="${this.layout}"></lvc-activity-pack-layout>
  `
  css = () => `
      :host {
        ${!this.items || (this.items as any[]).length === 0 ? 'display: none;' : ''}
      }
      /* @media screen and (min-width: 600px) {
        lvc-primary-slider {
          height: 450px;
        }
      } */
      lvc-grid-layout {
        display: ${!this.layout || this.layout === 'grid' ? 'grid' : 'none'};
      }
      lvc-primary-slider {
        display: ${this.layout === 'slider' ? 'block' : 'none'};
      }
      .view-more-layout {
        display: ${!this.layout || (this.layout === 'grid' && !this.isDisableSeeMore()) ? 'flex' : 'none'};
        margin: auto;
        justify-content: center;
        margin-top: 60px;
      }
      #view-more {
        font-size: 1.5rem;
        font-weight: 500;
        color: #1E007D;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        gap: 20px;
        cursor: pointer;
      }
      .view-more-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 72px;
        height: 72px;
        background-color: #ffffff;
        border-radius: 100%;
      }
      lvc-arrow-right-icon {
        width: 35px;
        height: 35px;
        transform: rotate(-25deg);
      }
      .view-more-text {
        border-bottom: 1px solid #1E007D;
      }
      .title-container {
        display: ${!this.layout || this.layout === 'grid' ? 'none' : 'flex'};
        align-items: center;
        column-gap: 10px;
        cursor: pointer;
      }
      @media only screen and (max-width: 991px) {
        lvc-grid-layout {
          display: none;
        }
        lvc-primary-slider {
          display: block;
        }
        .title-container {
          display: flex;
        }
        .view-more-layout {
          display: none;
        }
      }
      .counter {
        display: inline-flex;
        height: 34px;
        min-width: 34px;
        padding: 7px;
        justify-content: center;
        align-items: center;
        border-radius: 40px;
        background: #1E007D;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        color: #FF4600;
        position: relative;
        top: 2px;
      }
    
  `
  eventListeners: EventListeners = [
    [window, 'lvc:activity-pack-see-more', this.viewMore.bind(this)],
    ['.title-container', 'click', this.viewMore.bind(this)],
    ['#view-more', 'click', this.viewMore],
  ]
}
